module.exports = __webpack_public_path__ + "img/loginTitle.b64f4a4e.png";